import MuiCardActions, { CardActionsProps as MuiCardActionsProps } from '@mui/material/CardActions';
import React, { FC } from 'react';
import { BpDesignSystem } from '../../types';

export type CardActionsProps = BpDesignSystem.PropsWithChildren<MuiCardActionsProps & {}>;

export const CardActions: FC<CardActionsProps> = ({ dataTest, ...props }) => (
  <MuiCardActions data-test={dataTest} {...props} />
);
